import begin from "./begin";
import wallet from "./wallet";
import trade from "./trade";
import panel from "./panel";
export default {
  begin,
  wallet,
  trade,
  panel,
};
